/* src/app/builder-screen-beta/components/data-source-config/data-source-config.component.scss */
gi nz-form-item {
  margin-bottom: 16px;
}
nz-form-label {
  font-weight: 500;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
nz-space {
  width: 100%;
}
nz-space input[nz-input]:first-of-type {
  font-family: monospace;
}
.test-result-container {
  margin-top: 16px;
}
.test-result-container pre {
  font-size: 12px;
  line-height: 1.6;
}
nz-radio-group label {
  margin-right: 16px;
}
.formula-display {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}
.formula-display pre {
  margin: 0;
  font-size: 13px;
}
.variables-container nz-tag {
  margin: 4px;
}
/*# sourceMappingURL=data-source-config.component.css.map */
